// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"f1537a30","191":"195ad5c6","219":"ea796861","419":"0fbe6fb2","640":"0fbe6fb2"}[chunkId] + ".chunk.css";
};